<template>
    <div>
        <h3>{{ $t('filter.filterList') }}</h3>
        <div class="box-filter">
            <div class="box-filter__label">{{ $t('filter.filterTitle') }}</div>
            <div class="box-filter__items">
                <div class="d-flex flex-row align-items-center padding-10 text-bold">
                    <div class="mr-3 w-25">{{ $t('filter.content1') }}</div>
                    <div class="mr-3 w-25">{{ $t('filter.content2') }}</div>
                    <div class="w-40">{{ $t('filter.content3') }}</div>
                </div>
                <div v-for="(itemFilter, indexFilter) in filterContents" :key="indexFilter" class="box-filter__item">
                    <SelectCustom classes="mr-3 w-25" v-model="itemFilter.field" @change="onChangeTypeFilter(itemFilter.field, indexFilter)">
                        <template #options>
                            <el-option v-for="(item, index) in listFilters" :key="index + 'field'" :label="item.label" :value="item.code">
                                {{ item.label }}
                            </el-option>
                        </template>
                    </SelectCustom>
                    <SelectCustom classes="mr-3 w-25" v-model="itemFilter.type" v-if="itemFilter.field !== TYPE_ALL_RECORD">
                        <template #options>
                            <el-option v-for="(item, index) in itemFilter.listTypeConditions" :key="index + 'condition'" :label="item.label" :value="item.value">
                                {{ item.label }}
                            </el-option>
                        </template>
                    </SelectCustom>
                    <div class="w-40 input-options" v-if="itemFilter.field !== TYPE_ALL_RECORD">
                        <SelectCustom classes="w-100" v-if="['in', 'not in'].includes(itemFilter.type)" v-model="itemFilter.value" allow-create is-multi>
                            <template #options>
                                <el-option v-for="(item, indexC) in itemFilter.options" :value="item.value" :label="item.label" :key="indexC">
                                    {{ item.label }}
                                </el-option>
                            </template>
                        </SelectCustom>
                        <InputText v-if="!['in', 'not in'].includes(itemFilter.type) && !itemFilter.typeDate" v-model="itemFilter.value"></InputText>
                        <div v-if="itemFilter && itemFilter.typeDate">
                            <el-date-picker v-if="itemFilter.typeField === 'DATE'" format="yyyy/MM/dd" value-format="yyyy-MM-ddTHH:mm:ssZ" v-model="itemFilter.value"> </el-date-picker>
                            <el-date-picker v-if="itemFilter.typeField === 'DATETIME' || 'CREATED_TIME' || 'UPDATED_TIME'" format="yyyy/MM/dd HH:mm" type="datetime" value-format="yyyy-MM-ddTHH:mm:ssZ" v-model="itemFilter.value">
                            </el-date-picker>
                            <el-time-select
                                :picker-options="{
                                    start: '00:00',
                                    step: '00:30',
                                    end: '23:30'
                                }"
                                v-if="itemFilter.typeField === 'TIME'"
                                v-model="itemFilter.value"
                            >
                            </el-time-select>
                        </div>
                    </div>
                    <i class="el-icon-remove icon-remote cursor-pointer" @click="onDeleteFieldFilter(indexFilter)" v-if="itemFilter.field !== TYPE_ALL_RECORD"></i>
                </div>

                <div class="box-filter__item-add cursor-pointer" @click="onAddFilterField">
                    <el-icon class="el-icon-circle-plus"></el-icon>
                </div>
                <div class="box-filter__item-condition">
                    <RadioList v-model="conditionType" :data-list="listTypeFilters"></RadioList>
                </div>
                <div class="box-filter__item-clear">
                    <Button @click="onDeleteAllFilter" type="primary">
                        {{ $t('filter.buttonClearAll') }}
                    </Button>
                </div>
                <div class="box-filter__item-clear mt-5">
                    <div class="text-note-button" v-if="isAddCondition">
                        <span class="font-weight-bold mr-3">
                            {{ $t('filter.descriptionButton1') }}
                        </span>
                        <span>{{ $t('filter.descriptionButton2') }}</span>
                    </div>
                    <Button @click="onSearchDataView" type="primary" classes="w-100 py-2">
                        <el-icon class="el-icon-search mr-2"></el-icon>
                        {{ $t('button.search') }}
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import RadioList from '@/components/partials/RadioList';
import SelectCustom from '@/components/partials/customs/SelectCustom';
import InputText from '@/components/partials/customs/InputText';
import Button from '@/components/partials/Button';
import { listTypeFilters, listTypeText, listTypeTextArea, listTypeSelect, listTypeNumber, listTypeDate, listMultiLineText, listTypeLink } from './index';
import { mapState } from 'vuex';

export default {
    name: 'form-filter-kintone',
    props: {
        isAccountAdmin: { type: Boolean, required: true, default: false },
        appId: { required: true, default: '' },
        workspaceUid: { required: true, default: '' },
        listFieldsKeys: { required: false, default: null }
    },
    components: {
        RadioList,
        SelectCustom,
        InputText,
        Button
    },
    data() {
        return {
            listAllFields: [],
            TYPE_ALL_RECORD: 'All_Record',
            conditionType: 1,
            listTypeFilters,
            listTypeText,
            listTypeTextArea,
            listTypeSelect,
            listTypeNumber,
            listTypeDate,
            listMultiLineText,
            listTypeLink,
            listFilters: [],
            listUsers: [],
            listDepartments: [],
            listGroups: [],
            isAddCondition: false,
            filterContents: [
                {
                    field: 'All_Record',
                    type: '1',
                    value: '',
                    typeField: '',
                    listTypeConditions: []
                }
            ]
        };
    },
    computed: {
        ...mapState('share', ['filterContentSave']),

        allFieldFilter() {
            return [this.isAccountAdmin, this.appId, this.workspaceUid];
        }
    },
    watch: {
        allFieldFilter: {
            deep: true,
            immediate: true,
            handler(val) {
                if (!this.isAccountAdmin && this.appId) {
                    this.getAllFieldFilter();
                }
            }
        },
        filterContentSave: {
            deep: true,
            immediate: true,
            handler: function (val) {
                if (val.length > 0) {
                    this.filterContents = val;
                }
            }
        }
    },
    methods: {
        getAllFieldFilter() {
            let successCallback = (response) => {
                let { data } = response.data;
                this.listFilters = data.views.field;
                this.listFilters.unshift({
                    label: this.$t('filter.allRecord'),
                    code: 'All_Record',
                    type: ''
                });
                this.listUsers = mapToSelectList(data?.views?.user);
                this.listGroups = mapToSelectList(data?.views?.group);
                this.listDepartments = mapToSelectList(data?.views?.department);
                function mapToSelectList(items) {
                    return items?.length
                        ? items.map((value) => ({
                              value: value?.code,
                              label: value?.name
                          }))
                        : [];
                }
            };
            let errorCallback = () => {};

            let payload = {
                successCallback,
                errorCallback,
                appId: this.appId,
                spaceUid: this.workspaceUid
            };
            this.$store.dispatch('connect/getAllFieldFilter', payload);
        },
        onChangeTypeFilter(field, indexField) {
            if (field) {
                let index = this.listFilters.findIndex((elm) => elm.code === field);
                if (index >= 0) {
                    let type = this.listFilters[index].type;
                    let objectOptions = this.listFilters[index].options;
                    let options = [];
                    if (Object.entries(objectOptions).length) {
                        for (const item in objectOptions) {
                            options.push({
                                value: item,
                                label: objectOptions[item].label
                            });
                        }
                    }
                    let listTypeResult = [];
                    this.filterContents[indexField].value = '';
                    this.filterContents[indexField].typeField = type;
                    this.filterContents[indexField].typeDate = false;
                    this.filterContents[indexField].options = options;
                    switch (type) {
                        case 'DATE':
                        case 'DATETIME':
                        case 'CREATED_TIME':
                        case 'UPDATED_TIME':
                        case 'TIME':
                            listTypeResult = this.listTypeDate;
                            this.filterContents[indexField].typeDate = true;
                            break;
                        case 'FILE':
                        case 'RECORD_NUMBER':
                        case 'NUMBER':
                        case 'CALC':
                            listTypeResult = this.listTypeNumber;
                            break;
                        case 'MODIFIER':
                        case 'CREATOR':
                        case 'USER_SELECT':
                            listTypeResult = this.listTypeSelect;
                            this.filterContents[indexField].value = [];
                            this.filterContents[indexField].options = this.listUsers;
                            break;
                        case 'ORGANIZATION_SELECT':
                            listTypeResult = this.listTypeSelect;
                            this.filterContents[indexField].value = [];
                            this.filterContents[indexField].options = this.listDepartments;
                            break;
                        case 'GROUP_SELECT':
                            listTypeResult = this.listTypeSelect;
                            this.filterContents[indexField].value = [];
                            this.filterContents[indexField].options = this.listGroups;
                            break;
                        case 'DROP_DOWN':
                        case 'CHECK_BOX':
                        case 'RADIO_BUTTON':
                        case 'MULTI_SELECT':
                            listTypeResult = this.listTypeSelect;
                            this.filterContents[indexField].value = [];
                            break;
                        case 'SINGLE_LINE_TEXT':
                        case 'RICH_TEXT':
                            listTypeResult = this.listTypeText;
                            break;
                        case 'MULTI_LINE_TEXT':
                            listTypeResult = this.listMultiLineText;
                            break;
                        case 'LINK':
                            listTypeResult = this.listTypeLink;
                            break;
                        default:
                            listTypeResult = this.listTypeText;
                            break;
                    }
                    this.filterContents[indexField].listTypeConditions = listTypeResult;
                    if (listTypeResult && listTypeResult.length > 0) {
                        this.filterContents[indexField].type = listTypeResult[0].value;
                    }
                }
            }
        },
        onAddFilterField() {
            this.filterContents.push({
                field: '',
                type: '',
                value: '',
                typeField: ''
            });
        },
        onDeleteAllFilter() {
            this.filterContents = [
                {
                    field: 'All_Record',
                    type: '',
                    value: '',
                    typeField: ''
                }
            ];
        },
        onDeleteFieldFilter(index) {
            if (index > 0) {
                this.filterContents.splice(index, 1);
            } else {
                if (this.filterContents.length === 1) {
                    this.filterContents = [
                        {
                            field: 'All_Record',
                            type: '',
                            value: '',
                            typeField: ''
                        }
                    ];
                } else {
                    this.filterContents.splice(index, 1);
                }
            }
        },
        onSearchDataView() {
            let query = [];
            let queryContents = _.filter(this.filterContents, (elm) => elm.field && elm.field !== this.TYPE_ALL_RECORD);
            if (queryContents && queryContents.length > 0) {
                _.map(queryContents, (elm) => {
                    let typeValue = typeof elm.value;
                    if (typeValue === 'string' || typeValue === 'number') {
                        query.push(`${elm.field} ${elm.type} "${elm.value}"`);
                    } else if (typeValue === 'array' || typeValue === 'object') {
                        if (elm.value && elm.value.length > 0) {
                            let itemQuery = `${elm.field} ${elm.type} (${elm.value.map((elmValue) => `"${elmValue}"`).join(',')})`;
                            query.push(itemQuery);
                        }
                    }
                });
            }

            if (query.length > 0) {
                query = this.conditionType === 1 ? query.join(' and ') : query.join(' or ');
            } else {
                query = '';
            }

            this.$store.commit('share/isFilterData', {
                queryFilter: query,
                filterContentSave: this.filterContents
            });
        }
    }
};
</script>
